import { SAVINGS_LIMITS } from "shared/CalculatorLimits";
import { getAmountField } from "web_myplann/Calculators/Forms/getAmountField";
import { Resources } from "web_myplann/Infrastructure/Translations/Resources";
import type { TranslateFunction } from "web_myplann/Shared/TranslateFunction";
import { z } from "zod";

export const getSavingsFormSchema = (
	t: TranslateFunction,
	reasons: readonly [string, ...string[]],
) =>
	z.object({
		targetAmount: getAmountField(t, {
			min: SAVINGS_LIMITS.targetAmountMin,
			max: SAVINGS_LIMITS.targetAmountMax,
		}),
		reason: z.enum(reasons, {
			message: t(Resources.Form.Validations.required),
		}),
		years: z.number(),
	});
